import { HeaderItemLocation } from './../header/header-item-location';
import { Component, OnInit, Input } from '@angular/core';
import { GoBackService } from '../../services/go-back/go-back.service';
import { NgIf } from '@angular/common';
import { HeaderInjectDirective } from '../header/header-inject.directive';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'pcp-go-back-button',
    templateUrl: './go-back-button.component.html',
    styleUrls: ['./go-back-button.component.scss'],
    imports: [NgIf, HeaderInjectDirective, MatIconButton, MatTooltip, MatIcon]
})
export class GoBackButtonComponent implements OnInit {
  constructor(public goBack: GoBackService) {}

  @Input() location: HeaderItemLocation = HeaderItemLocation.start;
  ngOnInit() {}
}
